// extracted by mini-css-extract-plugin
export default {"dot":"css_dot__2cLUz","dotInner":"css_dotInner__apb+D"};